import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QueryParams, QueryParamsState } from './query-params.model';

const selectState = createFeatureSelector<QueryParamsState>('queryParamsState');

export const queryParamsState = createSelector(
  selectState,
  (state: QueryParamsState) => state
);

export const selectQueryParams = createSelector(
  selectState,
  (state: QueryParamsState) => state?.queryParams
);

export const selectWalletProvider = createSelector(
  selectQueryParams,
  (state: QueryParams) => state?.walletProvider
);

export const selectToken = createSelector(
  selectQueryParams,
  (state: QueryParams) => state?.token
);

export const selectLocale = createSelector(
  selectQueryParams,
  (state: QueryParams) => state?.locale
);

export const walletProvider = createSelector(
  selectQueryParams,
  (state: QueryParams) => state?.walletProvider
);

export const flowType = createSelector(
  selectQueryParams,
  (state: QueryParams) => (state && state.operation) || ''
);

export const queryAmount = createSelector(
  selectQueryParams,
  (state: QueryParams) => (state && state.amount ? state.amount : 0)
);
